import { EntityService } from '../../../service/EntityService';

export class UnitService extends EntityService {

  static entity = 'api/app/unit';

}
